<div fxLayout="row" class="background">
  <div fxFlex="80" fxFlexOffset="10%">
    <section id="header">
      <h1 class="h1Header">LIQUIDACIÓN PUNTO FIJO</h1>
    </section>
    <section id="table">
      <mat-card class="mat-elevation-z0">
        <form [formGroup]="cadetesForm" (ngSubmit)="search(cadetesForm.value)">
          <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
            <div fxFlex="25">
              <mat-form-field appearance="outline">
                <mat-label>Cadete</mat-label>
                <mat-select required formControlName="cadete">
                  <mat-option *ngFor="let delivery of allDeliveries" [value]="delivery.cdDelivery">
                    {{delivery.dsName}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="cadetesForm.controls['cadete']?.hasError('required')">
                  Este campo es obligatorio
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex="25">
              <mat-form-field appearance="outline">
                <mat-label>Punto fijo</mat-label>
                <mat-select formControlName="puntoFijo">
                  <mat-option [value]="''">Todos</mat-option>
                  <mat-option *ngFor="let client of allClients" [value]="client.cdClient">
                    {{client.dsNombreFantasia || client.dsRazonSocial}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxFlex="25">
              <mat-form-field appearance="outline">
                <mat-label>Desde</mat-label>
                <input matInput [matDatepicker]="dateFrom" (dateInput)="inpuDateFrom($event)" readonly>
                <mat-datepicker-toggle matSuffix [for]="dateFrom"></mat-datepicker-toggle>
                <mat-datepicker #dateFrom></mat-datepicker>
              </mat-form-field>
            </div>
            <div fxFlex="25">
              <mat-form-field appearance="outline">
                <mat-label>Hasta</mat-label>
                <input matInput [matDatepicker]="dateTo" (dateInput)="inpuDateTo($event)" readonly>
                <mat-datepicker-toggle matSuffix [for]="dateTo"></mat-datepicker-toggle>
                <mat-datepicker #dateTo></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="center center">
            <button mat-flat-button class="squared-btn" type="submit">Confirmar cabecera</button>
          </div>
        </form>
        <br>
        <table mat-table matTableExporter [dataSource]="dataSource" #exporter="matTableExporter" class="mat-elevation-z0">
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
              <mat-checkbox (change)="$event ? masterToggle() : null"
                          [checked]="selection.hasValue() && isAllSelected()"
                          [indeterminate]="selection.hasValue() && !isAllSelected()"
                          aria-label="Seleccionar todos los turnos">
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let session">
              <mat-checkbox (click)="$event.stopPropagation()"
                          (change)="$event ? toggle(session) : null"
                          [checked]="selection.isSelected(session)"
                          [aria-label]="'select ' + session.cdSession">
              </mat-checkbox>
            </td>
          </ng-container>
          <ng-container matColumnDef="cdSession">
            <th mat-header-cell *matHeaderCellDef class="table-header">TURNO</th>
            <td mat-cell *matCellDef="let session">{{ session.cdSession }}</td>
          </ng-container>
          <ng-container matColumnDef="dtStartTime">
            <th mat-header-cell *matHeaderCellDef class="table-header">INICIO</th>
            <td mat-cell *matCellDef="let session">{{ session.dtStartTime | argentinaDateTime }}</td>
          </ng-container>
          <ng-container matColumnDef="dtEndTime">
            <th mat-header-cell *matHeaderCellDef class="table-header">FIN</th>
            <td mat-cell *matCellDef="let session">{{ session.dtEndTime ? (session.dtEndTime | argentinaDateTime) : '-' }}</td>
          </ng-container>
          <ng-container matColumnDef="dsClient">
            <th mat-header-cell *matHeaderCellDef class="table-header">CLIENTE</th>
            <td mat-cell *matCellDef="let session">{{ session.dsClient || '-' }}</td>
          </ng-container>
          <ng-container matColumnDef="categoryName">
            <th mat-header-cell *matHeaderCellDef class="table-header">CATEGORÍA</th>
            <td mat-cell *matCellDef="let session">{{ session.categoryName || '-' }}</td>
          </ng-container>
          <ng-container matColumnDef="unitPrice">
            <th mat-header-cell *matHeaderCellDef class="table-header">PRECIO UNITARIO</th>
            <td mat-cell *matCellDef="let session">{{ session.unitPrice }}</td>
          </ng-container>
          <ng-container matColumnDef="hours">
            <th mat-header-cell *matHeaderCellDef class="table-header">HORAS</th>
            <td mat-cell *matCellDef="let session">{{ session.hours }}</td>
          </ng-container>
          <ng-container matColumnDef="totalCost">
            <th mat-header-cell *matHeaderCellDef class="table-header">COSTO TOTAL</th>
            <td mat-cell *matCellDef="let session">{{ session.totalCost }}</td>
          </ng-container>
          <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef class="table-header">ACCIONES</th>
            <td mat-cell *matCellDef="let session">
              <button mat-flat-button class="edit-rule-btn" (click)="openEditRuleDialog(session, $event)">
                Editar regla
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <br>
        <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
          <div fxLayout="column" fxFlex="70">
            <mat-form-field appearance="outline" class="formField">
              <mat-label>OBSERVACIONES</mat-label>
              <textarea matInput [(ngModel)]="observaciones"></textarea>
            </mat-form-field>
          </div>
          <div fxLayout="column" fxFlex="30">
            <mat-form-field appearance="outline" class="formField">
              <mat-label>Total horas</mat-label>
              <input disabled matInput [value]="totalHours">
            </mat-form-field>
            <mat-form-field appearance="outline" class="formField">
              <mat-label>Costo total</mat-label>
              <input disabled matInput [value]="totalCost">
            </mat-form-field>
            <mat-form-field appearance="outline" class="formField">
              <mat-label>Turnos</mat-label>
              <input disabled matInput [value]="totalSessions">
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5rem">
          <div fxFlex="30">
            <mat-form-field appearance="outline" class="quantity">
              <mat-label>Contraseña</mat-label>
              <input type="password" matInput required [(ngModel)]="password">
            </mat-form-field>
          </div>
          <div>
            <button mat-flat-button class="squared-btn" [disabled]="isSubmitting" (click)="confirmLiquidation()">
              {{ isSubmitting ? 'Emitiendo...' : 'Emitir liquidación' }}
            </button>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="0.5rem">
          <button mat-stroked-button type="button" (click)="exportPDF()">Exportar PDF</button>
          <button mat-stroked-button type="button" (click)="exportExcel()">Exportar Excel</button>
        </div>
      </mat-card>
    </section>
  </div>
</div>
